function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3394F6"
    },
    d: "M54.307,419.418c-7.412-3.706-10.415-12.715-6.709-20.127l35.596-71.177    c3.721-7.412,12.7-10.386,20.127-6.709c7.412,3.706,10.415,12.715,6.709,20.127l-35.596,71.177    C70.748,420.06,61.794,423.136,54.307,419.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3394F6"
    },
    d: "M144.307,419.418c-7.412-3.706-10.415-12.715-6.709-20.127l30-60    c3.706-7.412,12.729-10.371,20.127-6.709c7.412,3.706,10.415,12.715,6.709,20.127l-30,60    C160.748,420.06,151.794,423.136,144.307,419.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3394F6"
    },
    d: "M284.517,352.599l-30,60c-2.701,5.4-8.101,8.401-13.5,8.401c-2.1,0-4.501-0.601-6.599-1.5    c-7.5-3.9-10.501-12.902-6.901-20.101l13.5-26.999l16.5-33.001c3.9-7.5,12.9-10.499,20.099-6.899    C285.115,336.4,288.116,345.399,284.517,352.599z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -254.4175 118.0335)",
    style: {
      fill: "#3394F6"
    },
    cx: 75.988,
    cy: 497,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -240.4145 166.246)",
    style: {
      fill: "#3394F6"
    },
    cx: 165.988,
    cy: 497,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -226.4116 214.4585)",
    style: {
      fill: "#3394F6"
    },
    cx: 255.988,
    cy: 497,
    rx: 15,
    ry: 15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3394F6"
    },
    d: "M324.307,419.418c-7.412-3.706-10.415-12.715-6.709-20.127l30-60     c3.721-7.412,12.715-10.371,20.127-6.709c7.412,3.706,10.415,12.715,6.709,20.127l-30,60     C340.748,420.06,331.794,423.136,324.307,419.418z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -212.4086 262.6711)",
    style: {
      fill: "#3394F6"
    },
    cx: 345.988,
    cy: 497,
    rx: 15,
    ry: 15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -237.3127 86.9258)",
    style: {
      fill: "#3394F6"
    },
    cx: 30.988,
    cy: 452,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -223.3097 135.1383)",
    style: {
      fill: "#3394F6"
    },
    cx: 120.988,
    cy: 452,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -209.3068 183.3508)",
    style: {
      fill: "#3394F6"
    },
    cx: 210.988,
    cy: 452,
    rx: 15,
    ry: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8444 -0.5357 0.5357 0.8444 -195.3038 231.5633)",
    style: {
      fill: "#3394F6"
    },
    cx: 300.988,
    cy: 452,
    rx: 15,
    ry: 15
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3394F6"
    },
    d: "M284.517,352.599l-30,60c-2.701,5.4-8.101,8.401-13.5,8.401v-48.6l16.5-33.001   c3.9-7.5,12.9-10.499,20.099-6.899C285.115,336.4,288.116,345.399,284.517,352.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99B9D9"
    },
    d: "M496.016,150c0,49.501-40.499,90-90,90l-165-21l-117.001-15c-11.699-15.599-17.999-34.499-17.999-54   c0-49.501,40.499-90,90-90c3.3,0,6.599,0.3,9.901,0.601c7.8-17.1,20.099-31.501,35.099-41.7c17.1-12.001,37.8-18.9,60-18.9   c41.4,0,77.999,23.699,95.099,60.601C448.315,54.901,496.016,97.2,496.016,150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99B9D9"
    },
    d: "M496.016,150c0,49.501-40.499,90-90,90l-165-21V18.9c17.1-12.001,37.8-18.9,60-18.9   c41.4,0,77.999,23.699,95.099,60.601C448.315,54.901,496.016,97.2,496.016,150z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD9F1"
    },
    d: "M336.116,181.601C319.016,144.699,282.416,121,241.016,121s-77.999,23.699-95.099,60.601     c-52.5-5.7-99.901,36.599-99.901,89.399c0,49.501,40.499,90,90,90h210c49.501,0,90-40.499,90-90     C436.016,218.2,388.616,175.901,336.116,181.601z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD9F1"
    },
    d: "M436.016,271c0,49.501-40.499,90-90,90h-105V121c41.4,0,77.999,23.699,95.099,60.601   C388.616,175.901,436.016,218.2,436.016,271z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy);
export default __webpack_public_path__ + "static/media/rainy.f160f6b9b543023dd71946ac1da0426f.svg";
export { ForwardRef as ReactComponent };